module.exports = __webpack_public_path__ + "static/media/5-min.ff034a82.jpg";